
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import implicitModules from "./-embroider-implicit-modules.js";


import * as amdModule0 from "./app.ts"
import * as amdModule1 from "./config/environment.ts"
import * as amdModule2 from "./registry.ts"
import * as amdModule3 from "./router.ts"
import * as amdModule4 from "./services/docs.ts"
import * as amdModule5 from "./services/selected.ts"
import * as amdModule6 from "./utils.ts"
import * as amdModule7 from "./services/page-title.js"
import * as amdModule8 from "./services/kolay/api-docs.js"
import * as amdModule9 from "./services/kolay/compiler.js"
import * as amdModule10 from "./services/kolay/docs.js"
import * as amdModule11 from "./services/kolay/selected.js"
import * as amdModule12 from "./templates/application.gts"
import * as amdModule13 from "./controllers/application.ts"
import * as amdModule14 from "./routes/application.ts"
import * as amdModule15 from "./routes/index.ts"

let exportFastbootModules = {};





export default Object.assign(
  {},
  implicitModules,
  {
"tutorial/app": amdModule0,
"tutorial/config/environment": amdModule1,
"tutorial/registry": amdModule2,
"tutorial/router": amdModule3,
"tutorial/services/docs": amdModule4,
"tutorial/services/selected": amdModule5,
"tutorial/utils": amdModule6,
"tutorial/services/page-title": amdModule7,
"tutorial/services/kolay/api-docs": amdModule8,
"tutorial/services/kolay/compiler": amdModule9,
"tutorial/services/kolay/docs": amdModule10,
"tutorial/services/kolay/selected": amdModule11,
"tutorial/templates/application": amdModule12,
"tutorial/controllers/application": amdModule13,
"tutorial/routes/application": amdModule14,
"tutorial/routes/index": amdModule15,
  },
  exportFastbootModules
);
